import { NotificationString } from "./types/translated-strings.types";
import styles from "../notification.module.css";
import { NotificationStringItem } from "./NotificationStringItem";

interface NotificationStringListBodyProps {
  body: NotificationString[];
}
export const NotificationStringListBody = ({
  body,
}: NotificationStringListBodyProps) => (
  <div className={styles["notification-item-body"] ?? ""}>
    <div className={styles["notification-item-body-texts"] ?? ""}>
      {body.map((bodyItem, idx) => (
        <NotificationStringItem
          key={`notification-item-body-${idx}`}
          notificationString={bodyItem}
        />
      ))}
    </div>
  </div>
);
